import { VideoStreamController } from './VideoStreamController';
import { VideoStreamSupportedMediaType } from '../types';

/**
 * Controller for when a layout is configured with a VLC widget but is running on a player which
 * does not support VLC.
 */
export class VideoStreamUnsupportedVLCController extends VideoStreamController {
    readonly type: VideoStreamSupportedMediaType.VLC = VideoStreamSupportedMediaType.VLC;
    streamElement: HTMLDivElement;

    constructor() {
        super();

        this.streamElement = document.createElement('div');
        this.streamElement.style.height = '100%';
        this.streamElement.style.width = '100%';
    }

    async canBePlayed(): Promise<boolean> {
        return true;
    }

    async play(): Promise<void> {
        // show an unsupported error
        throw new Error(
            "Unsupported configuration. Video Stream Widgets will only display properly on REACH's windows-based player software on version 1.6 or greater and Signs version 1.2.0.17 or greater."
        );
    }
}
